























import { Component, Vue, Watch, Ref } from 'vue-property-decorator';
import DisplayItemChunk from '@/components/display-items/DisplayItemChunk.vue';
import PreviousDisplayItemsList from '@/components/display-items/PreviousDisplayItemsList.vue';


/**
 * Component for showing all display items in a single list, collapsable by partition
 * contains:
 * DisplayItemChunk
 */
@Component({
    props: {
        /**
         * Should the newest items be shown at the top
         */
        topFirst: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {
        PreviousDisplayItemsList,
        DisplayItemChunk
    }
})
export default class AllDisplayItemsList extends Vue {

    @Ref('allItemsList') private readonly allItemsList!: any;

    // The list of chunks since last partition has changed
    @Watch('recentDisplayChunks')
    private onRecentDisplayChunksChanged() {

        // Scroll new item into view
        if (this.$props.topFirst) {

            // Wait for change to be propagated
            Vue.nextTick(() => {
                this.scrollToTop();
            });
        } else {

            Vue.nextTick(() => {
                this.scrollToBottom();
            });
        }
    }

    get recentDisplayChunks() {
        if (this.$props.topFirst) {

            // Reverse a copy
            return this.$store.getters['performance/recentDisplayChunks'].slice().reverse();
        } else {
            return this.$store.getters['performance/recentDisplayChunks'];
        }
    }

    private scrollToBottom() {

        const el = document.scrollingElement;
        if (el) {
            el.scrollTop = el.scrollHeight;
        }
    }

    private scrollToTop() {

        const el = document.scrollingElement;
        if (el) {
            el.scrollTop = 0;
        }
    }

    // Recalulate scroll by distance from bottom for changed page height
    private recalcBottomScroll() {

        // Get scrolling element
        const el = document.scrollingElement;
        if (el == null) {
            return;
        }

        const oldScrollHeight = el.scrollHeight;
        const scroll = el.scrollTop;

        // Base scroll on distance from page bottom
        const scrollDeltaBottom = oldScrollHeight - scroll;

        Vue.nextTick(() => {
           Vue.nextTick(() => {

                const newScrollHeight = el.scrollHeight;

                // Reset scroll
                el.scrollTop = newScrollHeight - scrollDeltaBottom;
            });
        });
    }
}
